<template>
  <div style="width: 100%;display: flex;justify-content: center;">
    <div class="container">
      <div v-for="(item, index) in goodslist" :key='index' class="list" @click="ToGoodsInfo(item.GI_GUID)">
        <img v-lazy="GoodsImgUrl+item.GI_Cover" :name="index" alt="" style="width:100%;height: 190px;" />
        <!-- 	<img :src="GoodsImgUrl+item.GI_Cover"  alt="" style="width:100%;height: 200px;" /> -->
        <p class="Title">{{item.GI_Title}}</p>
        <p>原价:<span style="text-decoration:line-through">¥{{item.GI_FixPrice}}</span></p>
        <p>售价:<span>¥{{item.GI_Price}}</span></p>
        <!-- <p>{{item}}</p> -->
      </div>
    </div>
  </div>

  </div>
</template>

<script>
  import Common from '@/Global'
  export default {
    props: ['goodslist'],
    created: function() {
      // debugger
      // this.init();
    },
    data: function() {
      return {

        GoodsImgUrl: Common.GoodsImgUrl
      }
    },


    methods: {
//       init() {
//         debugger
//         var c=this.goodslist
//         //this.type = this.$route.params.type
// 
// 
//       },
      ToGoodsInfo(Guid) {
        this.$router.push({
          name: 'GoodsInfo',
          query: {
            GUID: Guid
          }
        });
      }
    }
  }
</script>

<style scoped>
  .container {
    width: 100%;
    height: auto;
    display: flex;
    display: -webkit-flex;
    /* justify-content: space-between; */
    flex-direction: row;
    flex-wrap: wrap;
    /* justify-content: center; */
  }
  .list{
     width: 30%;margin-left: 2%;
  }
  .Title{
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/GoosList_HomeSub.vue